import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ project }) => (
  <Link to={`/projects/${project.id}`} className="group block" data-testid={`project-card-${project.id}`}>
    <div className="img-frame aspect-[3/4] bg-[#F6F5F2] relative">
      <img src={imgUrl(project.cover_image)} alt={project.title} className="w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#2C2A29]/60 via-transparent to-transparent opacity-80" />
      <div className="absolute bottom-0 left-0 right-0 p-6 text-[#FFFFFF]">
        <p className="label-eyebrow text-[10px] text-[#ECEAE4]">{project.country} · {project.project_type}</p>
        <h3 className="font-display text-2xl font-medium mt-1 flex items-center gap-2">
          {project.title}
          <ArrowUpRight size={18} className="opacity-0 group-hover:opacity-100 transition-opacity" />
        </h3>
      </div>
    </div>
  </Link>
);
